import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-facing-decorator";
import Icon from "@/components/icon/Icon.vue";
import StandardButton from "@/components/buttons/StandardButton.vue";
import WAlert from "@/components/wrappers/w-alert.vue";
import QuizReadonlyAlert from "@/components/quiz/QuizReadonlyAlert.vue";
let QuizPreamble = class QuizPreamble extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "icon", void 0);
    _defineProperty(this, "title", void 0);
    _defineProperty(this, "items", void 0);
    _defineProperty(this, "canEdit", void 0);
    _defineProperty(this, "isSpeachTemplate", void 0);
  }
};
__decorate([Prop({
  default: ''
})], QuizPreamble.prototype, "icon", void 0);
__decorate([Prop({
  default: ''
})], QuizPreamble.prototype, "title", void 0);
__decorate([Prop({
  default: []
})], QuizPreamble.prototype, "items", void 0);
__decorate([Prop({
  default: false
})], QuizPreamble.prototype, "canEdit", void 0);
__decorate([Prop({
  default: false
})], QuizPreamble.prototype, "isSpeachTemplate", void 0);
QuizPreamble = __decorate([Component({
  components: {
    QuizReadonlyAlert,
    WAlert,
    StandardButton,
    Icon
  }
})], QuizPreamble);
export default QuizPreamble;